import React from 'react';
import * as Yup from 'yup';
import { loadDataHOC } from '../hoc';
import { orgObject } from '../lib/utils/schema';
import { BaseRHF, MaskedInputRHF } from '@cd/rhf';
import { DropDownRHF } from '@cd/rhf';
import { InputRHF } from '@cd/rhf';
import { FormCardRHF } from '@cd/rhf';
import { FormGroupRHF } from '@cd/rhf';
import { css } from '@emotion/react';
import useUpdateOrgInfo from './fetch/useUpdateOrgInfo';

const OrgInfoSchema = Yup.object().shape(orgObject);

const oneLineStyle = css({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between'
});
const oneLine2Style = css({
	display: 'flex',
	alignItems: 'center',
	'& > *:first-child': { marginRight: '16px' }
});

const loadDataForAccount = loadDataHOC('GET', '/account/org/get/info', {
	reactQuery: { queryName: 'getOrgInfo' }
});

const OrganizationInfo = ({ data: [states, data] }) => {
	const record = (data && data[0]) || {
		full_name: '',
		address_1: '',
		address_2: '',
		city: '',
		state_id: '',
		zip: '',
		phone: '',
		fax: ''
	};

	const { mutate } = useUpdateOrgInfo();
	function onValidationError(errors) {
		console.log('errors', errors);
	}

	return (
		<FormCardRHF
			mode="all"
			onSubmit={(values, formFns) => mutate(values, formFns)}
			schema={OrgInfoSchema}
			title="Organization information"
			subtitle="Update your organization info"
			okButtonTitle="UPDATE"
			defaultValues={record}
			onValidationError={onValidationError}>
			<FormGroupRHF
				style={css({ '.MuiFormControl-root': { flex: 1 } })}
				name="orgInfo">
				<InputRHF
					margin="normal"
					name="full_name"
					label="Organization Name"
				/>
			</FormGroupRHF>
			<FormGroupRHF style={oneLineStyle} name="orgInfo2">
				<InputRHF margin="normal" label="Address 1" name="address_1" />
				<InputRHF margin="normal" label="Address 2" name="address_2" />
			</FormGroupRHF>

			<FormGroupRHF style={oneLine2Style} name="address">
				<InputRHF margin="normal" name="city" label="City" />
				<BaseRHF
					render={props => (
						<DropDownRHF
							{...props}
							options={states}
							name="state_id"
							label="State"
						/>
					)}
					id="state"
					margin="normal"
					name="state_id"
					label="State"
				/>
				<InputRHF margin="normal" name="zip" label="ZIP" />
			</FormGroupRHF>
			<FormGroupRHF style={oneLine2Style} name="phones">
				<BaseRHF
					render={props => (
						<MaskedInputRHF
							{...props}
							label="Phone"
							mask="(000)000-0000"
						/>
					)}
					margin="normal"
					name="phone"
					label="Phone"
				/>
				<BaseRHF
					render={props => (
						<MaskedInputRHF
							{...props}
							label="Fax"
							mask="(000)000-0000"
						/>
					)}
					mask="(000)000-0000"
					margin="normal"
					name="fax"
					label="Fax"
				/>
			</FormGroupRHF>
		</FormCardRHF>
	);
};

export default loadDataForAccount(OrganizationInfo);
